import { render, staticRenderFns } from "./Sottogruppo.vue?vue&type=template&id=2d6ba59e"
import script from "./Sottogruppo.vue?vue&type=script&lang=js"
export * from "./Sottogruppo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports